/******************************************************
 * SERVER-SIDE RENDERING CHECK
 ******************************************************/
if (typeof window === 'undefined' || typeof document === 'undefined') {
    // Exit silently if running server-side
    module.exports = {};
} else {
(function() {

/******************************************************
 * 0. LOAD CLOUDFLARE TURNSTILE JS DYNAMICALLY
 ******************************************************/
(function loadTurnstileScript() {
    const script = document.createElement("script");
    script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
    script.async = true;
    script.defer = true;

    script.onload = () => console.log("Turnstile loaded");
    script.onerror = () => console.error("Turnstile failed to load");

    document.head.appendChild(script);
})();


/******************************************************
 * 1. Inject ALL CSS dynamically
 ******************************************************/
(function injectAllChatCSS() {
    const css = `
    .tdw-widget-trigger,
    .tdw-widget-trigger-container {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
      pointer-events: none !important;
    }

    #hl-chat-fab {
      position: fixed;
      bottom: 20px;
      right: 28px;
      width: 80px;
      height: 80px;
      border-radius: 50%;
      background: #12b5ea;
      border: 4px solid rgba(255,255,255,0.8);
      box-shadow: 0 12px 26px rgba(0,0,0,0.28),
                  0 0 18px rgba(122,92,62,0.35);
      cursor: pointer;
      z-index: 999999;
      opacity: 0;
      transform: scale(0.4) translateY(20px);
      transition: opacity 0.6s ease-out,
                  transform 0.6s cubic-bezier(.19,1,.22,1);
      animation: fabPulse 3.6s ease-in-out infinite;
      animation-delay: 1s;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
    }

    /* Mobile: Smaller button, bump it up */
    @media (max-width: 768px) {
      #hl-chat-fab {
        bottom: 78px;
        width: 60px;
        height: 60px;
        border: 3px solid rgba(255,255,255,0.8);
      }
    }

    #hl-chat-fab svg {
      width: 50%;
      height: 50%;
      filter: drop-shadow(0 2px 4px rgba(0,0,0,0.2));
    }

    @keyframes fabPulse {
      0%, 100% { transform: scale(1); }
      50% { transform: scale(1)in m; }
    }

    #hl-chat-bubble {
      position: fixed;
      bottom: 120px;
      right: 28px;
      background: white;
      padding: 12px 20px;
      border-radius: 20px;
      box-shadow: 0 6px 18px rgba(0,0,0,0.12);
      font-size: 16px;
      color: #444;
      font-weight: 600;
      opacity: 0;
      font-family:'HL-Whitney-Bold',sans-serif;
      transform: translateY(12px) scale(0.9);
      transition: opacity 0.4s ease,
                  transform 0.5s cubic-bezier(.19,1,.22,1);
      z-index: 999998;
    }

    /* Mobile: Adjust bubble position */
    @media (max-width: 768px) {
      #hl-chat-bubble {
        bottom: 158px;
        font-size: 14px;
        padding: 10px 16px;
      }
    }

    #challengeModal {
      position: fixed;
      top: 0; left: 0;
      width: 100%; height: 100%;
      background: rgba(0,0,0,0.65);
      display: none;
      justify-content: center;
      align-items: center;
      backdrop-filter: blur(3px);
      z-index: 99999;
      font-family:'HL-Whitney-Bold',sans-serif;
    }

    #challengeBox {
      background: white;
      width: 360px;
      padding: 26px;
      border-radius: 0px;
      box-shadow: 0 18px 34px rgba(0,0,0,0.28);
      text-align: center;
      animation: modalPop 0.38s cubic-bezier(.19,1,.22,1);
    }

    .hl-hidden { display: none; }

    @keyframes modalPop {
      0% { transform: scale(0.75) translateY(20px); opacity: 0; }
      100% { transform: scale(1) translateY(0); opacity: 1; }
    }
  `;

    const style = document.createElement("style");
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
})();


/******************************************************
 * 2. Inject ALL HTML elements
 ******************************************************/
(function injectChatHTML() {
    document.body.insertAdjacentHTML('beforeend', `
    <div id="hl-chat-fab" class="hl-hidden">
      <svg viewBox="-169.055 -135.244 338.11 270.488" xmlns="http://www.w3.org/2000/svg">
        <path fill="rgb(255,255,255)" fill-opacity="1" d="M-67.62200164794922,-135.24400329589844 C-67.62200164794922,-135.24400329589844 67.62200164794922,-135.24400329589844 67.62200164794922,-135.24400329589844 C123.64199829101562,-135.24400329589844 169.05499267578125,-89.83100128173828 169.05499267578125,-33.81100082397461 C169.05499267578125,22.20800018310547 123.64199829101562,67.62200164794922 67.62200164794922,67.62200164794922 C67.62200164794922,67.62200164794922 50.71699905395508,67.62200164794922 50.71699905395508,67.62200164794922 C50.71699905395508,67.62200164794922 -50.71699905395508,135.24400329589844 -50.71699905395508,135.24400329589844 C-50.71699905395508,135.24400329589844 -50.71699905395508,67.62200164794922 -50.71699905395508,67.62200164794922 C-50.71699905395508,67.62200164794922 -67.62200164794922,67.62200164794922 -67.62200164794922,67.62200164794922 C-123.64199829101562,67.62200164794922 -169.05499267578125,22.20800018310547 -169.05499267578125,-33.81100082397461 C-169.05499267578125,-89.83100128173828 -123.64199829101562,-135.24400329589844 -67.62200164794922,-135.24400329589844z"></path>
      </svg>
    </div>

    <div id="hl-chat-bubble" class="hl-hidden">
      Aloha! 🤙
      <small>How can we help?</small>
    </div>

    <div id="challengeModal">
      <div id="challengeBox">
        <h3>Please verify you’re human</h3>
        <div id="turnstileArea"></div>
      </div>
    </div>

    <div id="tdWebchat"></div>
  `);
})();


/******************************************************
 * 3. Turnstile + FAB Logic
 ******************************************************/
const SITE_KEY = "0x4AAAAAACAu2z8Fy0bFpiS8";
const WORKER_URL = "https://red-art-41af.hawaiilife.workers.dev";

window.addEventListener("load", () => {
    setTimeout(() => {
        const fab = document.getElementById("hl-chat-fab");
        const bubble = document.getElementById("hl-chat-bubble");

        fab.classList.remove("hl-hidden");
        bubble.classList.remove("hl-hidden");

        requestAnimationFrame(() => {
            fab.style.opacity = 1;
            fab.style.transform = "scale(1)";
            bubble.style.opacity = 1;
            bubble.style.transform = "translateY(0) scale(1)";
        });

        setTimeout(() => bubble.style.opacity = 0, 4000);
    }, 1);
});

document.addEventListener("click", (e) => {
    if (!e.target.closest("#hl-chat-fab")) return;

    const modal = document.getElementById("challengeModal");
    const container = document.getElementById("turnstileArea");

    modal.style.display = "flex";
    container.innerHTML = "";

    const div = document.createElement("div");
    div.id = "cf-" + Date.now();
    container.appendChild(div);

    widgetId = turnstile.render(`#${div.id}`, {
        sitekey: SITE_KEY,
        size: "normal",
        callback: onTurnstileSuccess
    });
});

async function onTurnstileSuccess(token) {
    const response = await fetch(WORKER_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token })
    });

    const data = await response.json();
    if (data.success) {
        document.getElementById("challengeModal").style.display = "none";
        if (window.webchat) window.webchat.open();
    }
}


/******************************************************
 * 4. TALKDESK SDK - DEFERRED UNTIL AFTER LCP & FCP
 ******************************************************/
(function deferTalkdesk() {
    // Track which paint events have fired
    let fcpFired = false;
    let lcpFired = false;
    let talkdeskLoaded = false;

    console.log('[Talkdesk Defer] Waiting for FCP and LCP before loading widget');

    // Function that actually loads the Talkdesk SDK
    function loadTalkdeskSDK() {
        if (talkdeskLoaded) return;
        talkdeskLoaded = true;

        console.log('[Talkdesk Defer] Loading Talkdesk SDK now');

        const script = document.createElement("script");
        script.src = "https://talkdeskchatsdk.talkdeskapp.com/v2/talkdeskchatsdk.js";
        script.async = true;

        script.onload = () => {
            window.webchat = TalkdeskChatSDK("tdWebchat", {
                touchpointId: "a73d421c3d15426daeb573036e38fa8d",
                accountId: "",
                region: "td-us-1"
            });

            window.webchat.init({
                enableValidation: false,
                enableEmoji: true,
                enableUserInput: true,
                enableAttachments: true,
                styles: {
                    // Customize button text
                    startChatButtonLabel: "START CONVERSATION",

             
                    customButtonColor: "#FFFFFF", // Button text color (white)
                    customButtonBackgroundColor: "#12b5ea", // Other button backgrounds

                    // Customize chat theme colors
                    // Optional: Customize bot/agent messages
                    botBackgroundColor: "#F2F4F5", // Agent message bubble
                    botTextColor: "#333333" // Agent message text
                }
            });

            const fab = document.getElementById("hl-chat-fab");

            window.webchat.onOpenWebchat = () => {
                fab.style.display = "none";
            };

            window.webchat.onCloseWebchat = () => {
                fab.style.display = "flex";
            };

            console.log('[Talkdesk Defer] Talkdesk SDK initialized');
        };

        document.head.appendChild(script);
    }

    // Check if both FCP and LCP have fired
    function checkIfReadyToLoad() {
        if (fcpFired && lcpFired) {
            console.log('[Talkdesk Defer] Both FCP and LCP fired - loading Talkdesk now');
            loadTalkdeskSDK();
        }
    }

    // Observer for FCP (First Contentful Paint)
    const fcpObserver = new PerformanceObserver((list) => {
        const entries = list.getEntries();
        if (!fcpFired && entries.length > 0) {
            fcpFired = true;
            const fcpTime = entries[0].startTime / 1000;
            console.log(`[Talkdesk Defer] FCP fired at ${fcpTime.toFixed(2)}s`);
            fcpObserver.disconnect();
            checkIfReadyToLoad();
        }
    });

    // Observer for LCP (Largest Contentful Paint)
    const lcpObserver = new PerformanceObserver((list) => {
        const entries = list.getEntries();
        if (!lcpFired && entries.length > 0) {
            lcpFired = true;
            const lastEntry = entries[entries.length - 1];
            const lcpTime = (lastEntry.renderTime || lastEntry.loadTime) / 1000;
            console.log(`[Talkdesk Defer] LCP fired at ${lcpTime.toFixed(2)}s`);
            lcpObserver.disconnect();
            checkIfReadyToLoad();
        }
    });

    try {
        // Start observing both paint events
        fcpObserver.observe({ type: 'first-contentful-paint', buffered: true });
        lcpObserver.observe({ type: 'largest-contentful-paint', buffered: true });
    } catch (e) {
        // Fallback: PerformanceObserver not supported, load after window.load
        console.warn('[Talkdesk Defer] PerformanceObserver not supported, using window.load fallback');
        window.addEventListener('load', () => {
            setTimeout(() => {
                loadTalkdeskSDK();
            }, 1000);
        });
        return;
    }

    // Safety fallback: If paint events don't fire within 4 seconds, load anyway
    setTimeout(() => {
        if (!talkdeskLoaded) {
            console.log('[Talkdesk Defer] Timeout (4s) - loading Talkdesk regardless of paint events');
            loadTalkdeskSDK();
        }
    }, 4000);
})();

})(); // End SSR check wrapper
}
